function initCakeTabs() {
  const tabs = document.querySelector("[data-cake-tabs]");
  if (!tabs) return;

  const panels = document.querySelectorAll("[data-cake-panel]");

  function show(key) {
    // buttons: persist selected state
    tabs.querySelectorAll(".cake-tab").forEach((btn) => {
      btn.classList.toggle("tab-active", btn.dataset.tab === key);
    });

    // panels
    panels.forEach((panel) => {
      panel.classList.toggle(
        "is-active",
        panel.getAttribute("data-cake-panel") === key
      );
    });
  }

  tabs.addEventListener("click", (e) => {
    const btn = e.target.closest(".cake-tab");
    if (!btn) return;
    show(btn.dataset.tab);
  });

  // Default selection
  show("all");
}

document.addEventListener("DOMContentLoaded", initCakeTabs);
document.addEventListener("shopify:section:load", initCakeTabs);
